import { useEffect, useRef, useState } from 'react';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CustomDomainRedirectIframe from '../customDomainIframe';
import SnapchatAuthorizationModal from './SnapchatAuthorizationModal';

const SnapchatIntegration = (props) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const isCustomDomain = CommonHelper.CustomDomain();
  let intervalId = null;
  let isProcessing = false;
  const messageListenerRef = useRef(null);

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAccessTokenReceivedFromSnapchat();
    }, Config.Common.socialAccountsIntegrationInterval);

    return () => {
      clearInterval(intervalId);
      cleanupListener();
    };
  }, []);

  const getSnapchatOauthToken = () => {
    window.open(
      `${Config.Snapchat.authorizeUrl}?client_id=${Config.Snapchat.clientId}&scope=${Config.Snapchat.scope}&redirect_uri=${Config.Snapchat.redirectUri}&response_type=code`
    );
  };

  const cleanupListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current);
      messageListenerRef.current = null;
    }
  };

  const checkAccessTokenReceivedFromSnapchat = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'snapchat_code' && code && !isProcessing) {
          isProcessing = true;
          cleanupListener();
          clearInterval(intervalId);
          sendAccessTokenToServer(code);
        }
      };

      if (!messageListenerRef.current) {
        window.addEventListener('message', handleMessage);
        messageListenerRef.current = handleMessage;
      }
    } else {
      const code = localStorage.getItem('snapchat_code');
      const error = localStorage.getItem('snapchat_error');

      if (code) {
        localStorage.removeItem('snapchat_code');
        clearInterval(intervalId);
        sendAccessTokenToServer(code);
      } else if (error) {
        localStorage.removeItem('snapchat_error');
        clearInterval(intervalId);
        showToast(error, 'e');
        handleClose();
      }
    }
  };

  const snapchatSuccessCallback = (data, message) => {
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED, "SNAPCHAT");
    showToast(message, 's');
    handleClose();
  };

  const snapchatFailureCallback = (message) => {
    message && showToast(message, 'e');
    handleClose();
  };

  const sendAccessTokenToServer = (code) => {
    let formData = { code };
    let postProps = {
      url: integrateModuleURL.senSnapChatAccessToken, // Make sure this URL exists in your backend
      body: formData,
      successCallback: snapchatSuccessCallback,
      failureCallback: snapchatFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleClose = () => {
    props.handleClose();
    cleanupListener();
  };

  return (
    <>
      {isAuthorizationModalOpen && (
        <SnapchatAuthorizationModal 
          handleConnectSnapchat={getSnapchatOauthToken} 
          handleClose={handleClose} 
        />
      )}
      {isCustomDomain && <CustomDomainRedirectIframe serviceName="snapchat" />}
    </>
  );
};

export default SnapchatIntegration;